import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock, OverlayTrigger, Popover } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Field, reduxForm, formValueSelector, SubmissionError } from 'redux-form';
import ConfirmButton from '../../../../components/confirm-button';
import { pick, truncate } from 'lodash';
// Import Actions

import { deleteFilterMapping, updateFilterMapping, addFilterMapping } from '../../FilterActions';

class FilterMappingButton extends Component {
  constructor() {
    super();
    this.state = {
      deleting: false,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.open !== nextProps.open) {
      if (nextProps.open) {
        this.open(nextProps.mapping);
      } else {
        this.close();
      }
    }
  }

  close() {
    this.props.reset();
    this.props.onClose();
  }

  open(mapping) {
    this.props.initialize(mapping);
  }

  handleDelete() {
    const { filter, mapping } = this.props;
    const filterId = filter._id;
    const id = mapping._id;
    if (id) {
      this.setState({ deleting: true });
      this.props.dispatch(deleteFilterMapping(filterId, id)).then(() => {
        this.props.onDelete(mapping);
        this.close();
        this.setState({ deleting: false });
      });
    }
  }

  handleSubmit(data) {
    const { filter } = this.props;
    const filterId = filter._id;
    const validFields = ['_id', 'label', 'description'];
    const params = pick(data, validFields);
    const action = params._id ? updateFilterMapping : addFilterMapping;
    return this.props.dispatch(action(filterId, params))
      .then(
        ({ mapping }) => {
          this.props.onSuccess(mapping);
          this.close();
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          }
          throw new SubmissionError(e);
        },
      );
  }

  renderField({
    input, label, type, disabled, componentClass, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        {componentClass !== 'textarea' && <FormControl
          {...input}
          placeholder={label}
          type={type}
          disabled={submitting || disabled}
        />}
        {componentClass === 'textarea' && <FormControl
          {...input}
          placeholder={label}
          type={type}
          componentClass={componentClass}
          rows={3}
          disabled={submitting || disabled}
        />}
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const {
      error, handleSubmit, mapping,
      submitting, selectedId, open,
    } = this.props;
    const isEditing = selectedId !== undefined;
    const { deleting } = this.state;
    if (!mapping) {
      return null;
    }
    return (
      <Modal show={open} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing && <span>Edit Filter Group</span>}
            {!isEditing && <span>Add Filter Group</span>}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            {error && <strong className="text-danger">{error}</strong>}
            <Field name="label" type="text" component={this.renderField} label="Name" />
            <Field name="description" componentClass="textarea" type="textarea" component={this.renderField} label="Description" />
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-sm-6 col-sm-push-6">
                <Button bsStyle="link" disabled={submitting || deleting} onClick={this.close}>Cancel</Button>
                {<Button bsStyle="primary" disabled={submitting || deleting} type="submit">
                  {isEditing && <span>
                    {!submitting && <span><Fa name="edit" /> Update</span>}
                    {submitting && <span><Fa name="spinner" spin /> Updating</span>}
                  </span>}
                  {!isEditing && <span>
                    {!submitting && <span><Fa name="plus" /> Add</span>}
                    {submitting && <span><Fa name="spinner" spin /> Adding</span>}
                  </span>}
                </Button>}
              </div>
              {isEditing && <div className="col-sm-6 col-sm-pull-6 text-left">
                {!deleting && <ConfirmButton onConfirm={this.handleDelete}>
                  <span><Fa name="trash" /> Delete</span>
                </ConfirmButton>}
                {deleting && <Button bsStyle="danger" disabled={submitting || deleting}>
                  <Fa name="spinner" spin /> Deleting
                </Button>}
              </div>}
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const selector = formValueSelector('filterMappingButtonForm');

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    selectedId: selector(state, '_id'),
  };
}


FilterMappingButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filter: PropTypes.shape({}).isRequired,
  mapping: PropTypes.shape({}),
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  selectedId: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  onSuccess: PropTypes.func,
};
FilterMappingButton.defaultProps = {
  onDelete: () => {},
  onClose: () => {},
  onSuccess: () => {},
  mapping: null,
  open: false,
};

const FilterMappingButtonForm = reduxForm({
  form: 'filterMappingButtonForm',
})(FilterMappingButton);

export default connect(mapStateToProps)(FilterMappingButtonForm);
